import clsx from 'clsx';
import { Badge } from '@/components/ui/badge.js';
import {
  AttendancePolicyV2EscalationCounts,
  AttendancePolicyV2HighLevelColorMap,
  AttendancePolicyV2HighLevelLabelMap,
  AttendancePolicyV2SecondaryStatusLabelMap,
  TeacherAttendancePolicyActionLevel,
  TeacherAttendancePolicySecondaryStatus,
  attendancePolicyV2SecondaryStatusColor,
  toAttendancePolicyV2HighLevelStatus,
} from '@/lib/attendance-policy-v2-display.js';

interface AttendancePolicyV2StatusBadgeProps {
  actionLevel: TeacherAttendancePolicyActionLevel;
  secondaryStatuses?: TeacherAttendancePolicySecondaryStatus[];
  /** When set, high-level badge uses AIR-3215 thresholds instead of legacy actionLevel alone. */
  escalationCounts?: AttendancePolicyV2EscalationCounts;
  'data-testid'?: string;
}

export const AttendancePolicyV2StatusBadge = ({
  actionLevel,
  secondaryStatuses = [],
  escalationCounts,
  'data-testid': dataTestId,
}: AttendancePolicyV2StatusBadgeProps) => {
  const highLevel = toAttendancePolicyV2HighLevelStatus(actionLevel, escalationCounts);

  return (
    <div className="flex flex-col gap-1 items-start" data-testid={dataTestId}>
      <Badge
        data-testid={dataTestId ? `${dataTestId}-high-level` : undefined}
        className={clsx(
          'p-1 rounded-[6px] text-[14px] text-center font-bold',
          AttendancePolicyV2HighLevelColorMap[highLevel],
        )}
      >
        {AttendancePolicyV2HighLevelLabelMap[highLevel]}
      </Badge>
      {secondaryStatuses.length > 0 ? (
        <div className="flex flex-col gap-0.5 items-start">
          {secondaryStatuses.map((secondary) => (
            <Badge
              key={secondary}
              data-testid={dataTestId ? `${dataTestId}-secondary-${secondary}` : undefined}
              className={clsx(
                'px-1.5 py-0.5 rounded-[4px] text-[12px] font-medium',
                attendancePolicyV2SecondaryStatusColor(secondary),
              )}
            >
              {AttendancePolicyV2SecondaryStatusLabelMap[secondary]}
            </Badge>
          ))}
        </div>
      ) : null}
    </div>
  );
};
